import { render } from "./ManifestMapPage.vue?vue&type=template&id=34464356&ts=true"
import script from "./ManifestMapPage.vue?vue&type=script&lang=ts"
export * from "./ManifestMapPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__